import { overviewKey } from '../overviewCard';

/** Testid prefix, icons and copy keys for the net-working-capital card. */
export const NET_WORKING_CAPITAL = {
    slot: 'net-working-capital',
    // Assets against liabilities — a two-way movement, not a trend.
    icon: 'solar:transfer-vertical-bold-duotone',
    ctaIcon: 'solar:book-2-bold-duotone',
    keys: {
        title: overviewKey('netWorkingCapital', 'title'),
        question: overviewKey('netWorkingCapital', 'question'),
        assets: overviewKey('netWorkingCapital', 'assets'),
        liabilities: overviewKey('netWorkingCapital', 'liabilities'),
        difference: overviewKey('netWorkingCapital', 'difference'),
        emptyBody: overviewKey('netWorkingCapital', 'emptyBody'),
        emptyCta: overviewKey('netWorkingCapital', 'emptyCta'),
    },
};
